import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.scss';
import logo from '../../images/logo.svg';

function burgerToggleHandle() {
  const menu = document.getElementById('menu');
  const burgerContainer = document.getElementById('burger-container');
  menu.classList.toggle('active-menu');
  burgerContainer.classList.toggle('active');
}

function delayedToggleHandle() {
  setTimeout(() => {
    burgerToggleHandle();
  }, 250);
}

export default function Navbar() {
  return (
    <nav className='navbar' id='navbar'>
      <NavLink
        to='/'
        exact
        className='navlink'
        activeClassName='active-navlink'
      >
        <img
          className='logo'
          src={logo}
          alt='Shortly logo that links to main page'
        />
      </NavLink>
      <div
        className='burger-container'
        id='burger-container'
        onClick={burgerToggleHandle}
      >
        <span className='burger'></span>
      </div>
      <div className='navbar__menu' id='menu'>
        <ul className='navbar__links'>
          <li>
            <NavLink
              to='/'
              exact
              className='navlink'
              activeClassName='active-navlink'
            >
              <img
                className='logo'
                src={logo}
                alt='Shortly logo that links to main page'
              />
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/features'
              exact
              className='navlink'
              activeClassName='active-navlink'
              onClick={delayedToggleHandle}
            >
              Features
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/pricing'
              exact
              className='navlink'
              activeClassName='active-navlink'
              onClick={delayedToggleHandle}
            >
              Pricing
            </NavLink>
          </li>
          <li>
            <NavLink
              to='/resources'
              exact
              className='navlink'
              activeClassName='active-navlink'
              onClick={delayedToggleHandle}
            >
              Resources
            </NavLink>
          </li>
        </ul>
        <div className='bar'></div>
        <ul className='navbar__signin'>
          <li className='not-active'>Login</li>
          <li className='btn nav-btn not-active'>Sign Up</li>
        </ul>
      </div>
    </nav>
  );
}
